import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const Analysed: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><circle cx="12" cy="12" r="6" fill="currentColor" stroke="currentColor" strokeWidth="1.5" /><line x1="12" y1="19" x2="12" y2="5" stroke="white" strokeWidth="1.5" /><line x1="11.75" y1="11.75" x2="19.75" y2="11.75" stroke="white" strokeWidth="1.5" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Analysed;